import { t } from 'i18next'
import * as React from "react"
import { IOWidget, Updater, fromJSX } from "widgets-for-react"
import { getClassName } from "../../../../cms/blocks/utils.gen"
import { ParsedLinkItem, ParsedParagraphGridItemHighlight } from "../../../../drupal/types_and_parser/types"
import { CMSState } from "../../../drupalPage/state"

export type GridHighlightBlockProps = {
  index: number
  field_highlight_items: ParsedParagraphGridItemHighlight[]
  title: string
  link: ParsedLinkItem
}

export type GridHighlightBlockStyle = Partial<{
  block_classname: string,
  inner_classname: string,
  content_classname: string,
  list_classname: string,
  grid_item_classname: string,
  grid_article_classname: string,
  grid_link_classname: string,
  grid_content_classname: string,
  grid_header_classname: string,
  grid_label_classname: string,
  grid_title_classname: string,
  grid_intro_classname: string,
  grid_fauxlink_classname: string,
}>

export function GridHighlightBlock(
  props: GridHighlightBlockProps,
  options?: { style: GridHighlightBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX(
      setState => {
        return (
          // TODO:Check if going good
          <section className={getClassName(options, "block_classname", "")}>
            <div className={getClassName(options, "inner_classname", "")}>

              <div className={getClassName(options, "content_classname", "")}>

                {<ul className={getClassName(options, "list_classname", "")}>
                  {props.field_highlight_items.map((highlight, i) => {
                    return renderGridHighlightItem(highlight, options)
                  })}

                </ul>
                }

              </div>
            </div>
          </section>
        )
      },
    )
}

const renderGridHighlightItem = (highlight: ParsedParagraphGridItemHighlight,
  options?: { style: GridHighlightBlockStyle; key?: string }
) =>
  <li className={getClassName(options, "grid_item_classname", "")}>
    <article className={getClassName(options, "grid_article_classname", "")}>
      {highlight.field_link && highlight.field_link.url && highlight.field_link.title ?
        <a className={getClassName(options, "grid_link_classname", "")}
          href={highlight.field_link.url} >
          <div className={getClassName(options, "grid_content_classname", "")}>
            <header className={getClassName(options, "grid_header_classname", "")}>
              <h3 className={getClassName(options, "grid_title_classname", "")}><span>{highlight.field_title}</span></h3>
            </header>
            <p className={getClassName(options, "grid_intro_classname", "")}>
              {/* {highlight.field_introduction.length <= 300 ?
                highlight.field_introduction
                : highlight.field_introduction.slice(0, 300) + "..."} */}
              {highlight.field_introduction}
            </p>
            <span className={getClassName(options, "grid_fauxlink_classname", "")}>
              {t(`Button:read_more`)}
            </span>
          </div>
        </a>
        :
        <a className={getClassName(options, "grid_link_classname", "")} >
          <div className={getClassName(options, "grid_content_classname", "")}>
            <header className={getClassName(options, "grid_header_classname", "")}>
              <h3 className={getClassName(options, "grid_title_classname", "")}><span>{highlight.field_title}</span></h3>
            </header>
            <p className={getClassName(options, "grid_intro_classname", "")}> {highlight.field_introduction} </p>
          </div>
        </a>
      }
    </article>
  </li>
